import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import '../globalStyles';

const TemplateWrapper = ({ children, data }) => (
  <div>
    <Helmet
      title="Pretzel Tech"
      meta={[
        { name: 'description', content: 'Tasty tools for content creators' },
        { name: 'keywords', content: 'pretzel, pretzel rocks, pretzel tech, ninety9lives, 99l, royalty free, music, twitch, youtube, mixer' },
      ]}
    />
    <div>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js